import React, { ReactNode } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ToolButtons from '@ui-parts/ToolButtons';
import { ButtonProps } from '@mui/material/Button';
import HeaderBarWithToolButtons from '@ui-parts/HeaderBarWithToolButtons';
import Footer from '@ui-parts/Footer';
import { useNavigate } from 'react-router-dom';
import { isSigninPath } from '@functional';
import { PALETTE, HEADER } from '~/assets/styles/base';
import { PUBLIC_HEADER_TOOL_ITEMS, PUBLIC_HEADER_TOOLS_MASTER } from '~/constants';

const StyledBody = styled.div`
  min-height: 100vh;
  position: relative;
  padding-bottom: 60px;
  box-sizing: border-box;
`;

interface PublicPageWrapperProps {
  children: ReactNode;
}

interface ToolProps {
  id: string;
  label: string;
  variant: string;
  link: string;
}

const PublicPageWrapper = ({ children }: PublicPageWrapperProps) => {
  const navigate = useNavigate();

  const setToolButtons = () => {
    let res: ToolProps[] = [];
    const items: string[] = PUBLIC_HEADER_TOOL_ITEMS[window.location.pathname] || [];
    res = PUBLIC_HEADER_TOOLS_MASTER.filter((item) => items.includes(item.id));

    // maintain propety type for item.variant
    const newRes = res.map((item) => ({
      ...item,
      variant: item.variant as ButtonProps['variant'],
    }));

    // Convert link to navigate function and return
    return newRes.map((item) => ({
      ...item,
      func: () => navigate(item.link),
    }));
  };

  return (
    <StyledBody>
      {!isSigninPath() && (
        <HeaderBarWithToolButtons height={HEADER.headerBar.height} bgColor={PALETTE.bg.main}>
          <ToolButtons tools={setToolButtons()} />
        </HeaderBarWithToolButtons>
      )}
      {children}
      <Footer />
    </StyledBody>
  );
};

PublicPageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PublicPageWrapper;
